import React from 'react'
import { UIMainRegister } from '../../UI/Register-UI-Components/UIRegister/UIMainRegister/UIMainRegister';
import '../../Styles/Register-Styles/StylesRegister/StylesRegister.css'

export const PageHomeRegister =()=> {
  return (
    <div>
      <UIMainRegister/>
    </div>
  )
}
